import React, { useRef, useState } from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { compact } from 'utilities/array'
import { getDate } from 'utilities/date-time'
import { size } from 'utilities/object'
import { Option } from './s'
import Modal from 'modals/dialog'
import Form from 'components/form/controller'
import OneOfField from 'components/form/field/one-of'
import CheckboxField from 'components/form/field/checkbox'
import TimeField from 'components/form/field/time'
import { InlineMessage } from 'components/message'
import StatusLabel from 'components/status-label'
import Actions from 'components/form/actions'
import { BackButton, ButtonSubmit } from 'components/button'

const TwoWhat = ({ previous, next, formData, setFormData, salt }) => {
    const { formatMessage } = useIntl()

    const everythingRef = useRef()

    const [includeSalary, setIncludeSalary] = useState(formData?.includeSalary ?? false)
    const [salaryOnDate, setSalaryOnDate] = useState(formData?.salaryOnDate ?? getDate())

    const update = body => {
        setFormData(formData => ({
            ...formData,
            ...body,
            ...((!!includeSalary && salaryOnDate) ? { salaryOnDate } : null),
        }))

        next()
    }

    return (
        <Form
            layout="vertical"
            onSubmit={update}>
            {({ trigger, errors }) => (
                <>
                    <Modal.Body>
                        <OneOfField
                            name="what"
                            label={formatMessage({
                                id: 'label_export_what',
                                defaultMessage: 'What should be exported'
                            })}
                            field={{
                                value: 'everything',
                                required: true,
                                include: 'always',
                                options: compact([
                                    {
                                        value: 'everything',
                                        label: formatMessage({
                                            id: 'option_all_profile_fields',
                                            defaultMessage: 'All profile fields'
                                        }),
                                        content: (
                                            <>
                                                <CheckboxField
                                                    name="includeSalary"
                                                    label={formatMessage({
                                                        id: 'people_export_label_include_salary',
                                                        defaultMessage: 'Include salary'
                                                    })}
                                                    field={{ value: includeSalary }}
                                                    onChange={({ includeSalary }) => setIncludeSalary(includeSalary)}
                                                    interaction="switch"
                                                    salt={salt}
                                                    ref={everythingRef} />
                                                {!!includeSalary && (
                                                    <>
                                                        <TimeField
                                                            salt={salt}
                                                            label={formatMessage({
                                                                id: 'people_export_label_salary_on_date',
                                                                defaultMessage: 'Export salaries as if it was'
                                                            })}
                                                            name="salaryOnDate"
                                                            field={{ value: salaryOnDate }}
                                                            onChange={({ salaryOnDate }) => setSalaryOnDate(salaryOnDate)} />
                                                        <InlineMessage
                                                            type="info"
                                                            className="spacious"
                                                            message={formatMessage({
                                                                id: 'people_export_message_current_salary',
                                                                defaultMessage: 'Salaries will only be exported for those users you have access to salary information for.'
                                                            })} />
                                                    </>
                                                )}
                                            </>
                                        ),
                                        controlRef: everythingRef
                                    },
                                    {
                                        value: 'specific_fields',
                                        label: (
                                            <Option>
                                                <span>
                                                    <FormattedMessage
                                                        id="option_specific_fields"
                                                        defaultMessage="Specific fields" />
                                                </span>
                                                <StatusLabel className="passive">
                                                    <FormattedMessage
                                                        id="payment_plan_status_upcoming"
                                                        defaultMessage="Coming soon" />
                                                </StatusLabel>
                                            </Option>
                                        ),
                                        disabled: true
                                    }
                                ])
                            }}
                            salt={salt} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Actions className="spread">
                            <BackButton onClick={previous} />
                            <ButtonSubmit
                                className="constructive"
                                disabled={!!size(errors)}
                                ref={trigger}>
                                <FormattedMessage
                                    id="action_continue"
                                    defaultMessage="Continue" />
                            </ButtonSubmit>
                        </Actions>
                    </Modal.Footer>
                </>
            )}
        </Form>
    )
}

export default TwoWhat